import { Box } from "@mui/material";
import HeaderPhoto from "../../assets/images/generic_beauty.jpg";
import PageHeader from "../../components/PageHeader";
import BeautyGallery from "./Gallery";

function Beauty() {
  return (
    <Box>
      <PageHeader image={HeaderPhoto} title="Beauty" />
      <BeautyGallery />
    </Box>
  );
}

export default Beauty;
